
<template>
<div class="enterpriseInfo">
  <div class="card" v-if="showInfo || !enterpriseId">
    <div class="title"><span class="xin">*</span>营业执照</div>
    <div class="imageBox">
      <div class="uploadItem">
        <Upload-img @handleChange="getbusinessLicenseOcr" :disabled="uploadDisabled" :imageUrl="enterpriseInfo.businessLicense" v-loading="loading"></Upload-img>
        <div class="id_msg"></div>
        <div class="reminder" v-if="Ocrhint">营业执照识别不通过</div>
      </div>
    </div>
  </div>
<!--  <div class="card" v-if="source !='create' && (showInfo || !enterpriseId)">-->
<!--    <div class="title"><span class="xin">*</span>法人身份证正反面</div>-->
<!--    <div class="imageBox">-->
<!--      <div class="uploadItem">-->
<!--        <Upload-img @handleChange="getidCardOcr" :disabled="uploadDisabled" :imageUrl="enterpriseInfo.legalPersonIdCardBack" v-loading="loading"></Upload-img>-->
<!--        <div class="id_msg">人像</div>-->
<!--      </div>-->
<!--      <div class="uploadItem">-->
<!--        <Upload-img @handleChange="getidCardBack" :disabled="uploadDisabled" :imageUrl="enterpriseInfo.legalPersonIdCardFront" v-loading="loading"></Upload-img>-->
<!--        <div class="id_msg">国徽</div>-->
<!--      </div>-->
<!--      <div class="reminder" v-if="Cardhint">身份证识别不通过</div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="person" v-if="source !='create'">-->
<!--    <div>是否经办人办理</div>-->
<!--    <el-switch :disabled="uploadDisabled" v-model="isPerson" class="defineSwitch" inline-prompt  active-text="是" inactive-text="否">-->
<!--    </el-switch>-->
<!--  </div>-->
<!--  <div class="card" v-if="isPerson && source !='create'">-->
<!--    <div class="title"><span class="xin">*</span>经办人授权书</div>-->
<!--    <div class="power">-->
<!--      <div v-if="enterpriseInfo.letterOfAuthorization" @click="showPowerInfo" :class="enterpriseInfo.letterOfAuthorization?'link':'name' ">{{enterpriseInfo.letterOfAuthorization || '授权书'}}</div>-->
<!--      <el-upload-->
<!--          v-if="!uploadDisabled"-->
<!--          class="upload-demo"-->
<!--          action-->
<!--          :http-request="uploadFile"-->
<!--          :show-file-list="false">-->
<!--        <el-button type="text">选择上传</el-button>-->
<!--      </el-upload>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="card" v-if="isPerson && source !='create'">-->
<!--    <div class="title"><span class="xin">*</span>经办人身份证正反面</div>-->
<!--    <div class="imageBox">-->
<!--      <div class="uploadItem">-->
<!--        <Upload-img @handleChange="getAgentIdBack" :disabled="uploadDisabled" :imageUrl="enterpriseInfo.agentIdCardBack" v-loading="loading"></Upload-img>-->
<!--        <div class="id_msg">人像</div>-->
<!--      </div>-->
<!--      <div class="uploadItem">-->
<!--        <Upload-img @handleChange="getAgentIdFront" :disabled="uploadDisabled" :imageUrl="enterpriseInfo.agentIdCardFront" v-loading="loading"></Upload-img>-->
<!--        <div class="id_msg">国徽</div>-->
<!--      </div>-->
<!--      <div class="reminder" v-if="Cardhint">身份证识别不通过</div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="formData">
    <el-form ref="formInfo" size="small" :model="enterpriseInfo" :rules="rules" label-suffix="：" label-width="150px"  class="enterpriseInfoInfo" :disabled="uploadDisabled">
      <el-form-item v-if="source == 'create'" label="我的角色">
        <el-select style="width: 100%;" v-model="enterpriseInfo.userType" placeholder="我的角色">
          <el-option label="法人" :value="1"></el-option>
          <el-option label="经办人" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="法人姓名" prop="legalPerson">
        <el-input placeholder="法人姓名" v-model="enterpriseInfo.legalPerson"></el-input>
      </el-form-item>
      <el-form-item label="企业名称" prop="enterpriseName">
        <el-input placeholder="企业名称" v-model="enterpriseInfo.enterpriseName"></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="socialCreditCode">
        <el-input placeholder="社会信用代码" v-model="enterpriseInfo.socialCreditCode"></el-input>
      </el-form-item>
      <el-form-item label="企业地址" prop="address" class="specialItem">
        <el-input placeholder="地址" v-model="enterpriseInfo.address"></el-input>
      </el-form-item>
<!--      <template v-if="isPerson">-->
<!--        <el-form-item label="经办人姓名" prop="agentName">-->
<!--          <el-input placeholder="经办人姓名" v-model="enterpriseInfo.agentName"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="经办人身份证号码" prop="agentIdCardNumber">-->
<!--          <el-input placeholder="经办人身份证号码" v-model="enterpriseInfo.agentIdCardNumber"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="经办人手机号" prop="agentPhone">-->
<!--          <el-input placeholder="经办人手机号" v-model="enterpriseInfo.agentPhone"></el-input>-->
<!--        </el-form-item>-->
<!--      </template>-->
<!--      <template v-if="source !='create'">-->
<!--        <el-form-item label="法人姓名" prop="legalPersonIdCardName">-->
<!--          <el-input placeholder="姓名" v-model="enterpriseInfo.legalPersonIdCardName"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="法人身份证号" prop="legalPersonIdCardNumber">-->
<!--          <el-input placeholder="身份证号码" v-model="enterpriseInfo.legalPersonIdCardNumber"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="法人手机号" prop="legalPersonPhone">-->
<!--          <el-input placeholder="法人手机号" v-model="enterpriseInfo.legalPersonPhone">-->
<!--            <el-button v-if="!uploadDisabled && !isPerson" slot="append" type="text" @click="getVerifyCode()" :loading="downCode != 120"><span class="verify">{{downCode ==120 ? "获取验证码" :`${downCode}s` }}</span></el-button>-->
<!--          </el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item v-if="!uploadDisabled && !isPerson" label="验证码" prop="verCode">-->
<!--          <el-input placeholder="验证码" v-model="enterpriseInfo.verCode"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="法人联系地址" prop="legalPersonAddress">-->
<!--          <el-input placeholder="法人联系地址" v-model="enterpriseInfo.legalPersonAddress"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="约定账单日" prop="appointBillDate">-->
<!--          <el-select placeholder="约定账单日" v-model="enterpriseInfo.appointBillDate" style="width:100%">-->
<!--            <el-option v-for="item in 28" :key="item" :label="item" :value="`${item}`"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="约定的支付周期" prop="appointPaymentCycle">-->
<!--          <el-select placeholder="约定的支付周期" v-model="enterpriseInfo.appointPaymentCycle" style="width:100%">-->
<!--            <el-option v-for="item in paymentList" :key="item.label" :label="item.label" :value="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--      </template>-->
    </el-form>
    <div class="errTips">请仔细核对信息！！！确认无误后再提交</div>
  </div>
  <div v-if="!uploadDisabled" class="buttonGroup">
    <el-button  size="small" type="text" @click="$router.back()">返回上一步</el-button>
    <div class="submitBtn">
      <el-button size="small" type="primary" @click="handleSubmitInfo"  :loading="btnLoading">提交企业信息</el-button>
    </div>
  </div>
</div>
</template>
<script>
import {putFile} from "@/api/userInfoPort";
import {addEnterpriseInfo, businessLicenseOcr, idCardOcr, legalPersonVerCode,enterpriseInfoDetails} from "@/api/enterprise";
import {addOrderUserLeasePattern} from "@/api/order";

export default {
  name:'enterpriseInfo',
  data(){
    return {
      enterpriseId:'',
      source:'user',
      timer: null,
      downCode:120,
      powerInfo:{
        authorizationUrl:"",
        name:''
      },
      isPerson:false,
      showInfo:false,
      loading:false,
      Ocrhint: false,
      Cardhint: false,
      uploadDisabled:false,
      enterpriseInfo: {
        enterpriseName: '',
        address: '',
        legalPerson: '',
        businessLicense:'',
        categoryBig:'',
        userType:1,
        socialCreditCode:''

      },
      currentPage:1,
      rules: {
        enterpriseName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        socialCreditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        address: [{ required: true, message: '请输入企业地址', trigger: 'blur' }],
        legalPerson: [{ required: true,  message: '请输入法人姓名', trigger: 'blur' }],
        legalPersonIdCardNumber: [{ required: true, message: '请输入法人身份证号', trigger: 'blur' }],
        legalPersonPhone: [{ required: true, message: '请输入法人手机号', trigger: 'blur' }],
        legalPersonAddress: [{ required: true, message: '请输入法人联系地址', trigger: 'blur' }],
        appointBillDate: [{ required: true, message: '请选择约定的账单日', trigger: 'blur' }],
        appointPaymentCycle: [{ required: true, message: '请输入约定的支付周期', trigger: 'blur' }],
        verCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      paymentList: [
        {
          label: '月付',
          value: '0'
        },
        {
          label: '季付',
          value: '1'
        },
        {
          label: '半年付',
          value: '2'
        },
        {
          label: '年付',
          value: '3'
        }
      ],
      // 合同签署状态
      contractSignStatus: false,
      // 控制按钮是否被点击状态
      btnLoading: false
    }
  },
  created() {
    if(this.$route.query.source){
      this.source = this.$route.query.source
    }
    if(this.$route.query.enterpriseId){
      this.enterpriseId = this.$route.query.enterpriseId
      this.getEnterpriseDetail()
    }
  },
  methods:{
    datePickerOptions() {
      let startDate
      // 开始为当前日期判断4点前和4点后
      const currentDate = new Date() // Get the current date and time
      const currentHour = currentDate.getHours() // Get the current hour (in 24-hour format)
      // 1天
      let d = 1000 * 60 * 60 * 24
      if (currentHour > 16) {
        startDate = currentDate.getTime() + d
      } else {
        startDate = currentDate.getTime()
      }
      let time = new Date(startDate)
      let year = time.getFullYear() //年
      let month = ('0' + (time.getMonth() + 1)).slice(-2) //月
      let day = ('0' + time.getDate()).slice(-2) //日
      let expectDeliveryDate = year + '-' + month + '-' + day

      return expectDeliveryDate
    },
    getEnterpriseDetail(){
      enterpriseInfoDetails({enterpriseId:this.enterpriseId}).then(res=>{
        if(res.data.code == 200){
          this.enterpriseInfo = res.data.data
          const {agentIdCardNumber,agentPhone,letterOfAuthorization} = res.data.data
          this.isPerson = agentIdCardNumber && agentPhone && letterOfAuthorization?true:false
          this.uploadDisabled = true
          this.showInfo = true
        }
      })
    },
    getbusinessLicenseOcr(url) {
      this.loading = true
      businessLicenseOcr({fileUrl:url})
          .then((res) => {
            this.loading = false
            if (res.data.code == 200) {
              this.Ocrhint = false
              this.enterpriseInfo ={...this.enterpriseInfo,...res.data.data}
              this.enterpriseInfo.businessLicense = url
              // this.enterpriseInfo.enterpriseName = res.data.data.enterpriseName
              // this.enterpriseInfo.legalPerson = res.data.data.legalPerson
              // this.enterpriseInfo.socialCreditCode = res.data.data.socialCreditCode
              // this.enterpriseInfo.address = res.data.data.address
              this.$message({
                message: '上传成功',
                type: 'success'
              })

              this.handleChangeBar()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
              this.enterpriseInfo.businessLicense = ''
              this.Ocrhint = true
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
    getidCardOcr(url) {
      this.loading = true
      idCardOcr({fileUrl:url})
          .then((res) => {
            this.loading = false
            if (res.data.code == 200) {
              this.Cardhint = false
              this.enterpriseInfo.legalPersonIdCardName = res.data.data.name
              this.enterpriseInfo.legalPersonIdCardNumber = res.data.data.idCardNumber
              this.enterpriseInfo.legalPersonAddress = res.data.data.address
              this.enterpriseInfo.legalPersonIdCardBack = url
              this.$message({
                message: '上传成功',
                type: 'success'
              })
              this.handleChangeBar()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
              this.enterpriseInfo.legalPersonIdCardBack = ''
              this.Cardhint = true
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
    getidCardBack(url) {
      this.enterpriseInfo.legalPersonIdCardFront = url
      this.handleChangeBar()
    },
    handleChangeBar() {
      let { businessLicense, legalPersonIdCardBack, legalPersonIdCardFront, letterOfAuthorization } = this.enterpriseInfo
      let curData = {
        businessLicense,
        legalPersonIdCardBack,
        legalPersonIdCardFront,
        letterOfAuthorization
      }
      let list = Object.values(curData)
      let len = list.length
      switch (len) {
        case 0:
          this.progress = 0
          break
        case 1:
          this.progres = 12
          break
        case 2:
          this.progress = 24
          break
        case 3:
          this.progress = 36
          break
        case 4:
          this.progress = 48
          break

        default:
          break
      }
    },
    handleSubmitInfo() {
      this.$refs['formInfo'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          addEnterpriseInfo(this.enterpriseInfo).then((res) => {
                if (res.data.code == 200) {
                 if(this.source == 'place'){
                   this.$message.success('提交成功')
                   this.onSubmitted(res.data.data)
                 }else {
                   this.$message.success('绑定企业成功')
                   this.$router.back()
                 }
                }
                setTimeout(() => {
                  this.btnLoading = false
                }, 1000)
              })
              .catch((err) => {
                this.btnLoading = false
                return Promise.reject(err)
              })
        }
      })
    },
    uploadFile(item){
      let fileExt = item.file.name.split('.').pop().toLowerCase()
      if (fileExt !== 'jpg' && fileExt !== 'jpeg' && fileExt !== 'png' && fileExt !== 'pdf') {
        this.$message.error('仅支持jpg,jpeg,png,pdf格式！')
        return false;
      }
      let FormDatas = new FormData()
      FormDatas.append('file', item.file)
      putFile(FormDatas).then(res=>{
        if(res.data.code == 200){
          this.enterpriseInfo.letterOfAuthorization = res.data.data.link
          this.powerInfo.name = res.data.data.originalName
        }
      })
    },
    showPowerInfo(){
      if(this.enterpriseInfo.letterOfAuthorization){
        window.open(this.enterpriseInfo.letterOfAuthorization, '_blank')
      }
    },
    getAgentIdBack(url){
      this.enterpriseInfo.agentIdCardBack = url
      idCardOcr({fileUrl:url}).then(res=>{
        if(res.data.code == 200){
          let {idCardNumber,name} = res.data.data
          this.enterpriseInfo ={...this.enterpriseInfo, agentIdCardNumber:idCardNumber,agentName:name}
        }
      })
    },
    getAgentIdFront(url){
      this.enterpriseInfo.agentIdCardFront = url
    },
    async onSubmitted(id) {
      let currentCommodityDetail = JSON.parse(localStorage.getItem('currentCommodityDetail'))
      let data = {
        adChannel: currentCommodityDetail.adChannel,
        commodityNumber: currentCommodityDetail.commodityNumber,
        isEnterpriseOrder: true,
        expectDeliveryDate: this.datePickerOptions(),
        lat: '',
        leasePatternId: currentCommodityDetail.leasePatternId,
        lng: '',
        orderRemark: currentCommodityDetail.orderRemark,
        shareOpenId: currentCommodityDetail.shareOpenId,
        skuId: currentCommodityDetail.commoditySkuId,
        enterpriseId: id
      }
      addOrderUserLeasePattern(data).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.$router.push({ path: '/Submitted', query: { orderId: res.data.data.orderId, isEnterpriseOrder: true } })
        } else {
          this.$message.error(res.data.msg)
        }
      })
          .catch(() => {
            // this.$message.error('请重新下单')
          })
    },
    getVerifyCode(){
      let userNameRule = /^1[3-9]\d{9}$/
      if(userNameRule.test(this.enterpriseInfo.legalPersonPhone)){
        legalPersonVerCode({legalPersonPhone:this.enterpriseInfo.legalPersonPhone}).then(({data})=>{
          if(data.code==200){
            this.$message.success('发送成功')
            this.timer =  setInterval(()=>{
              this.downCode--
              if(this.downCode==0){
                this.downCode = 120
                clearInterval(this.timer)
              }
            },1000)
          }else{
            this.$message.warning(data.msg)
          }
        })
      }else{
        this.$message.warning('请输入正确的手机号！')
      }
    },
  }
}
</script>
<style scoped lang="scss">
.enterpriseInfo {
  max-width: 1430px;
  margin: 20px auto;
  .card{
    background: #fff;
    margin-bottom: 20px;
    padding: 20px;
    .title{
      border-bottom: 1px solid #dae1e8;
      line-height: 40px;
      .xin{
        color: red;
        margin-right: 5px;
      }
    }
    .imageBox{
      display: flex;
      margin-top: 20px;
      .uploadItem{
        width: 30%;
        margin-right: 20px;
        .id_msg ,.reminder{
          text-align: center;
          margin-top: 10px;
        }
        .reminder{
          color: red;
        }
      }
    }
    .power{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 0 20px;
      .link{
        color: #409eff;
        cursor: pointer;
      }
      .name{
        color: #5e5e5e;
      }
    }
  }
  .formData ,.buttonGroup, .person{
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    .errTips{
      color: red;
      padding-left: 20px;
      font-size: 14px;
    }
  }
  .person{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    .defineSwitch{
      ::v-deep .el-switch__label--left {
        position: relative;
        left: 50px;
        color: #fff;
        z-index: -1111;
      }
      ::v-deep .el-switch__core{
        width: 50px!important;
      }
      ::v-deep .el-switch__label--right {
        position: relative;
        right: 50px;
        color: #fff;
        z-index: -1111;
      }
      ::v-deep .el-switch__label--right.is-active {
        z-index: 1111;
        color: #fff!important;
      }
      ::v-deep .el-switch__label--left.is-active {
        z-index: 1111;
        color: #9c9c9c!important;
      }
    }
  }
  .buttonGroup{
    display: flex;
    //text-align: center;
    .submitBtn{
      width: 100%;
      text-align: center;
    }
  }
}
</style>